import {
    Popup
} from 'vant'
import {
    getAddressList
} from '@/models/confirmOrder'
import {
    delAddressById
} from '@/models/editAddress'
import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    name: 'addressListCard',
    data () {
        return {
            selected_id: '', // 选中的id
            show: false,
            addressList: []
        }
    },
    props: {
        // addressList: {
        //     type: Array,
        //     default: []
        // }
    },
    created () {},
    activated () {
        this.getAddressList()
    },
    methods: {
        ...mapActions(['setAddressInfo', 'clearAddressInfo']),
        closeModel () {
            this.show = false
        },
        openModel () {
            this.show = true
            this.getAddressList()
        },
        navigation (item) {
            // 跳转
            this.$router.push({
                name: 'editAddress',
                query: {
                    delivery_id: item.id
                }
            })
        },
        async getAddressList () {
            let addressList = await getAddressList()
            this.addressList = addressList.data
        },
        del (item) {
            // 弹窗询问时否需要删除此数据
            this.$dialog
                .alert({
                    showCancelButton: true,
                    title: '提示',
                    message: '确定删除此收货地址?'
                })
                .then(async () => {
                    // on close
                    // 删除某个元素
                    await delAddressById({
                        delivery_id: item.id
                    })
                    // 需要看一下是否删除已经选中的
                    if (this.addressInfo.delivery_id === item.id) {
                        this.clearAddressInfo()
                    }
                    this.getAddressList()
                })
                .catch(() => {})
        },

        changeSelected (event, item) {
            event.preventDefault()
            this.selected_id = item.id
            this.setAddressInfo({
                delivery_id: item.id,
                consignee: item.consignee,
                address: item.address,
                phone_tel: item.phone_tel,
                region_name: item.region_name
            })
            this.closeModel()
        }
    },
    components: {
        'van-popup': Popup
    },
    computed: {
        ...mapGetters(['addressInfo']),

        // 判断无地址
        isNotList () {
            return this.addressList.length > 0
        },
        // 样式计算
        buttonStyle () {
            return this.isNotList
                ? 'add-address-button'
                : 'add-address-nodata-button'
        }
    }
}
